"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = AlertSmall;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _AlertSmall = require("@adobe/react-spectrum-ui/dist/AlertSmall");

var _icon = require("@react-spectrum/icon");

var _provider = require("@react-spectrum/provider");

var _react = _interopRequireDefault(require("react"));

const ExpressIcon = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  viewBox: "0 0 14 14"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  d: "M12.717 8.678 9 2.175C8.422 1.103 7.058.689 5.954 1.25a2.225 2.225 0 0 0-.95.92L1.278 8.687a2.198 2.198 0 0 0 .058 2.238A2.264 2.264 0 0 0 3.278 12h7.445a2.264 2.264 0 0 0 1.941-1.075 2.2 2.2 0 0 0 .053-2.247ZM6.133 4.133c0-.478.388-.866.866-.867.478 0 .867.388.868.866v3a.868.868 0 0 1-1.734.002V4.133ZM7 11.1c-.661 0-1.2-.538-1.2-1.2 0-.661.538-1.2 1.2-1.2.661 0 1.2.538 1.2 1.2 0 .661-.538 1.2-1.2 1.2Z"
}));

ExpressIcon.displayName = _AlertSmall.AlertSmall.displayName;

function AlertSmall(props) {
  var _provider$theme, _provider$theme$globa;

  let provider = (0, _provider.useProvider)();
  return /*#__PURE__*/_react.default.createElement(_icon.UIIcon, props, provider != null && (_provider$theme = provider.theme) != null && (_provider$theme$globa = _provider$theme.global) != null && _provider$theme$globa.express ? /*#__PURE__*/_react.default.createElement(ExpressIcon, null) : /*#__PURE__*/_react.default.createElement(_AlertSmall.AlertSmall, null));
}